<template>
  <div class="dynamic-tables">
    <h2 class="page-title text-center">Penilaian Pelaksanaan UPT</h2>
    <Widget customHeader>
      <table class="table" style="width: 100%">
        <thead>
          <tr>
            <th>Jenis</th>
            <th>Prioritas</th>
            <th>Nama UPT</th>
            <th>No. KKPRL</th>
            <th>Nama Pemegang</th>
            <th>Metode</th>
            <th>Tanggal Penilaian</th>
            <th>Status</th>
            <th>Aksi</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="data in dataPenilaian" :key="data.id">
            <td>{{ data.jenis }}</td>
            <td>
              <span :class="['badge', data.prioritas === 'Ya' ? 'bg-success' : 'bg-secondary']">
                {{ data.prioritas }}
              </span>
            </td>
            <td>{{ data.nama_upt }}</td>
            <td>{{ data.nomor_kkprl }}</td>
            <td>{{ data.nama_pemegang }}</td>
            <td>{{ data.metode }}</td>
            <td>{{ formatDate(data.tanggal_penilaian, 'DD MMMM YYYY') }}</td>
            <td>{{ data.status }}</td>
            <td>
              <b-button size="sm" variant="primary" @click="lihatDetail(data.id)">
                <i class="fa fa-eye"></i> Detail
              </b-button>
            </td>
          </tr>
        </tbody>
      </table>
    </Widget>
  </div>
</template>

<script>
import { formatDate } from '@/helper/helpernew'

export default {
  name: 'PenilaianPelaksanaanUpt',
  data() {
    return {
      dataPenilaian: [
        { id: 1, jenis: 'Pertama', prioritas: 'Ya', nama_upt: 'BPRL Padang', nomor_kkprl: 'KKPRL-PP-UPT-2026-001', nama_pemegang: 'PT Samudra Nusantara', metode: 'Lapangan', tanggal_penilaian: '2026-01-15', status: 'Belum Dinilai' },
        { id: 2, jenis: 'Lanjutan', prioritas: 'Tidak', nama_upt: 'LPRL Serang', nomor_kkprl: 'KKPRL-PP-UPT-2026-002', nama_pemegang: 'PT Bahari Sejahtera', metode: 'Terpusat', tanggal_penilaian: '2026-02-10', status: 'Dalam Proses' },
        { id: 3, jenis: 'Pertama', prioritas: 'Tidak', nama_upt: 'BPRL Makasar', nomor_kkprl: 'KKPRL-PP-UPT-2026-003', nama_pemegang: 'CV Laut Biru', metode: 'Lapangan', tanggal_penilaian: '2026-03-05', status: 'Selesai' },
        { id: 4, jenis: 'Lanjutan', prioritas: 'Ya', nama_upt: 'LPRL Sorong', nomor_kkprl: 'KKPRL-PP-UPT-2026-004', nama_pemegang: 'PT Marina Timur', metode: 'Terpusat', tanggal_penilaian: '2026-04-20', status: 'Belum Dinilai' },
        { id: 5, jenis: 'Pertama', prioritas: 'Ya', nama_upt: 'BPRL Padang', nomor_kkprl: 'KKPRL-PP-UPT-2026-005', nama_pemegang: 'PT Pesisir Makmur', metode: 'Lapangan', tanggal_penilaian: '2026-05-12', status: 'Dalam Proses' },
        { id: 6, jenis: 'Lanjutan', prioritas: 'Tidak', nama_upt: 'LPRL Serang', nomor_kkprl: 'KKPRL-PP-UPT-2026-006', nama_pemegang: 'PT Mina Bahari', metode: 'Terpusat', tanggal_penilaian: '2026-06-18', status: 'Selesai' },
        { id: 7, jenis: 'Pertama', prioritas: 'Tidak', nama_upt: 'BPRL Makasar', nomor_kkprl: 'KKPRL-PP-UPT-2026-007', nama_pemegang: 'PT Samudra Jaya', metode: 'Lapangan', tanggal_penilaian: '2026-07-09', status: 'Belum Dinilai' },
        { id: 8, jenis: 'Lanjutan', prioritas: 'Ya', nama_upt: 'LPRL Sorong', nomor_kkprl: 'KKPRL-PP-UPT-2026-008', nama_pemegang: 'CV Bahari Lestari', metode: 'Terpusat', tanggal_penilaian: '2026-08-22', status: 'Dalam Proses' },
        { id: 9, jenis: 'Pertama', prioritas: 'Ya', nama_upt: 'BPRL Padang', nomor_kkprl: 'KKPRL-PP-UPT-2026-009', nama_pemegang: 'PT Pulau Indah', metode: 'Lapangan', tanggal_penilaian: '2026-09-14', status: 'Selesai' },
        { id: 10, jenis: 'Lanjutan', prioritas: 'Tidak', nama_upt: 'LPRL Serang', nomor_kkprl: 'KKPRL-PP-UPT-2026-010', nama_pemegang: 'PT Kelautan Abadi', metode: 'Terpusat', tanggal_penilaian: '2026-10-09', status: 'Belum Dinilai' },
      ],
    }
  },
  methods: {
    formatDate,
    lihatDetail(id) {
      this.$router.push({ name: 'FormPenilaianPelaksanaanUpt', params: { id } })
    },
  },
}
</script>
